import Glide, { Breakpoints, Controls, Swipe, Images } from '@glidejs/glide/dist/glide.modular.esm';
import { getDir } from '../../common/components/utils/utils';

const SELECTORS = {
	root: '[data-slider-explore-countries]',
	slider: '.explore-countries__slides',
	slides: '.explore-countries__slide',
	images: '.explore-countries__bg',
};

const ATTRIBUTES = {
	bgActive: 'explore-countries__bg--active',
	slideActive: 'explore-countries__slide--active',
	slideInView: 'explore-countries--inview',
};

export class CountriesSlider {
	constructor() {
		this.rootEl = document.querySelector(SELECTORS.root);
		this.allImages = document.querySelectorAll(SELECTORS.images);
		this.slidesContainer = document.querySelector(SELECTORS.slider);
		this.allSlides = document.querySelectorAll(SELECTORS.slides);
		this.slideActive = document.querySelector(`.${ATTRIBUTES.slideActive}`);

		const requiredElements = [this.rootEl, this.allImages, this.slidesContainer, this.allSlides];

		if (requiredElements.some((el) => !el)) {
			return;
		}

		this.bindEvents();
		this.setup();
	}

	static init() {
		// eslint-disable-next-line
		new CountriesSlider();
	}

	setupSlider() {
		this.slider = new Glide(this.rootEl, {
			type: 'slider',
			perView: 4.4,
			startAt: this.slideActive.dataset.destination,
			gap: 24,
			focusAt: 'center',
			rewind: false,
			direction: getDir(),
			animationDuration: 800,
			animationTimingFunc: 'linear',
			swipeThreshold: 40,
			breakpoints: {
				1200: {
					perView: 3.6,
					gap: 18,
				},
				1000: {
					perView: 3.2,
					gap: 16,
				},
				800: {
					perView: 2.6,
					gap: 16,
				},
				600: {
					perView: 1.2,
					gap: 16,
				},
			},
		}).mount({ Controls, Breakpoints, Swipe, Images });

		// set initial transforms of slides content
		this.allSlides.forEach((slide, i) => {
			if (i !== +this.slideActive.dataset.destination) {
				slide.firstElementChild.style.transform = `translate3d(0, ${
					(slide.firstElementChild.offsetHeight - 40) / 2
				}px, 0)`;
			}
		});

		// Prevent the initial transitions while the slider is setting up
		this.slidesContainer.classList.add('explore-countries--loaded');

		// Remove --active classes before slider starts moving to enable transitions on fading away slides
		this.slider.on('run.before', () => this.onSlideChange(this.slider, 'remove'));
		// Add --active classes to upcoming active slider to enable transitions
		this.slider.on('move', () => this.onSlideChange(this.slider, 'add'));
	}

	bindEvents() {
		['changeSlideOnClick'].forEach((e) => {
			this[e] = this[e].bind(this);
		});
	}

	changeSlideOnClick(event) {
		if (event.target.dataset.destination) {
			this.slider.go(`=${event.target.dataset.destination}`);
		}
	}

	onSlideChange(slider, action) {
		const { index } = slider;

		this.allImages[index].classList[action](ATTRIBUTES.bgActive);
		this.allSlides[index].classList[action](ATTRIBUTES.slideActive);

		this.allSlides[index - 1]?.classList[action](ATTRIBUTES.slideInView);
		this.allSlides[index + 1]?.classList[action](ATTRIBUTES.slideInView);

		if (action === 'add') {
			this.allSlides[index].classList[action](ATTRIBUTES.slideInView);
		}

		this.setSlideInfoTransform(index, action);
	}

	setSlideInfoTransform(item, action) {
		// If 'add'-ed --active class, info container gets translated back to its initial position
		// If 'remove'-ed info text fades away and gets translated downwards to display only heading
		if (action === 'add') {
			this.allSlides[item].firstElementChild.style.transform = `translate3d(0, 0, 0)`;
		} else {
			const infoHeight = this.allSlides[item].firstElementChild.offsetHeight;
			this.allSlides[item].firstElementChild.style.transform = `translate3d(0, ${
				(infoHeight - 40) / 2
			}px, 0)`;
		}
	}

	setupEventListeners() {
		this.slidesContainer.addEventListener('click', this.changeSlideOnClick);
	}

	setup() {
		this.setupEventListeners();
		this.setupSlider();
	}
}
